(() => {
  const locale = window.Shopify?.locale || document.documentElement.lang || '';

  if (!locale.toLowerCase().startsWith('en')) return;

  const englishTranslation = {
    stockWidget: {
      modal: {
        heading: "Be the first to know when it's back",
        subheading:
          'This item is currently sold out. Enter your email address and we will let you know as soon as it is available again.',
        notifyButtonTitle: 'Notify me',
        privacyText: 'We will use your email address only to notify you when this item is available again.',
        emailPlaceholder: 'Email address',
        successText: "You're on the waitlist. We will email you as soon as your size is available again.",
        successCloseText: 'Close',
        optInMarketingText: 'Sign up for the newsletter?',
      },
    },
  };

  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };

  const localizeWidgetFrame = () => {
    const iframe = document.getElementById('gw-stock-fulfilled-iframe');

    if (!iframe) return;

    try {
      const iframeDocument = iframe.contentDocument;

      if (!iframeDocument) return;

      setText(iframeDocument.querySelector('.modal-title'), englishTranslation.stockWidget.modal.heading);
      setText(iframeDocument.querySelector('.notification-message'), englishTranslation.stockWidget.modal.subheading);
      setText(iframeDocument.querySelector('.notify-button'), englishTranslation.stockWidget.modal.notifyButtonTitle);
      setText(iframeDocument.querySelector('.privacy-text'), englishTranslation.stockWidget.modal.privacyText);
      setText(iframeDocument.querySelector('.gw-success-message .success-text'), englishTranslation.stockWidget.modal.successText);
      setText(iframeDocument.querySelector('.gw-success-message .close-text'), englishTranslation.stockWidget.modal.successCloseText);

      const emailInput = iframeDocument.querySelector('input[type="email"]');
      if (emailInput) emailInput.placeholder = englishTranslation.stockWidget.modal.emailPlaceholder;

      iframeDocument.querySelectorAll('small, .error, .gw-error').forEach((element) => {
        if (/gültige e-mail-adresse/i.test(element.textContent || '')) {
          setText(element, 'Enter a valid email address.');
        }
      });
    } catch (_error) {
      // The app owns the iframe. Its built-in translation hook below remains the primary path.
    }
  };

  const localizeWidget = () => {
    const widget = window.initVar;

    if (!widget) return false;

    widget.translationJson = widget.translationJson || {};
    widget.translationJson.en = englishTranslation;
    widget.translationJson[locale] = englishTranslation;

    if (widget.stockWidget) {
      widget.stockWidget.subscriptionText = 'Join the waitlist';
      widget.stockWidget.subscribedText = "You're on the waitlist";
    }

    document.querySelectorAll('#backinstock .gw-button-widget[gw-stock-fulfilled]').forEach((button) => {
      setText(button, 'Join the waitlist');
    });

    if (typeof widget.translateStockWidget === 'function') widget.translateStockWidget();
    localizeWidgetFrame();

    return true;
  };

  let attempts = 0;
  const interval = window.setInterval(() => {
    attempts += 1;
    localizeWidget();

    if (attempts >= 120) window.clearInterval(interval);
  }, 250);

  const observer = new MutationObserver(localizeWidget);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(() => observer.disconnect(), 30000);
})();
